import { secondAxios } from "../../../../../../../api/axios";

const fetchDocumentsByProject = async (projectId, type) => {
  if (!projectId) return [];
  const documentType = type || "all";
  const response = (
    await secondAxios.get(`/documents/${projectId}/type/${documentType}`)
  ).data;
  console.log("dd", response);
  return response;
};

export const getProjectDocumentList = async (type, projectId) => {
  return fetchDocumentsByProject(projectId, type);
};

export const getPlantDocumentList = async (type, plantId) => {
  if (!plantId) return [];
  try {
    const res = await secondAxios.get(`/plant/${plantId}`);
    const projectsRaw =
      res.data?.projects ||
      (Array.isArray(res.data?.project)
        ? res.data.project
        : res.data?.project
        ? [res.data.project]
        : Array.isArray(res.data)
        ? res.data
        : []);

    if (!Array.isArray(projectsRaw) || projectsRaw.length === 0) {
      return [];
    }

    // Filter projects by current client
    const filteredProjects = projectsRaw.filter(
      (p) => p.clientName === process.env.REACT_APP_CLIENT_NAME
    );

    if (filteredProjects.length === 0) {
      return [];
    }

    const docsByProject = await Promise.all(
      filteredProjects.map(async (project) => {
        const docs = await fetchDocumentsByProject(project?.id, type);
        return docs.map((doc) => ({
          ...doc,
          projectId: project?.id,
          projectName: project?.name,
        }));
      })
    );

    const allDocuments = docsByProject.flat();
    console.log("plantssssss", allDocuments);
    
    // Filter out duplicate titles - keep only the first occurrence of each title
    const seenTitles = new Set();
    const uniqueDocuments = allDocuments.filter((doc) => {
      const title = doc?.title?.toLowerCase()?.trim();
      if (!title) return true; // Keep documents without titles
      if (seenTitles.has(title)) {
        return false; // Skip duplicate
      }
      seenTitles.add(title);
      return true; // Keep first occurrence
    });
    
    return uniqueDocuments;
  } catch (error) {
    console.error("Failed to load plant documents", error);
    return [];
  }
};

// export const getRACI = async () => {
//   const raciData = await secondAxios.get("/raci");
//   return raciData;
// };
export const updateDocumentList = async (updateDocument, id) => {
  console.log("updated", updateDocument);
  const updateDocumentDto = {
    title: updateDocument.title,
    // department: updateDocument.department,
    docNumber: updateDocument.number,
    responsible: updateDocument.responsible,
  };
  await secondAxios.patch(`/documents/${updateDocument.id}`, updateDocumentDto);
};

export const createDocumentList = async (type, projectId, newDoc) => {
  const resp = await secondAxios.post(`/documents/${projectId}`, {
    type,
    ...newDoc,
  });
};

export const deleteDocumentList = async (id) => {
  try {
    await secondAxios.delete(`/documents/:${id}`);
  } catch (error) {
    console.log(error);
  }
};
